import { LinkType } from "@did/types/uikit";
import React from "react";
export const Link: LinkType = ({ children, handleClick, className }) => {
  return (
    <a className={`cursor-pointer ${className}`} onClick={handleClick}>
      {children}
    </a>
  );
};
